/* eslint-disable @typescript-eslint/no-explicit-any */
import { LoopObjectVo, RootObjectVo } from "../checkout.interface";

/**
 * 判断当前楼层
 * @param floor
 * @param namespace
 */
function definedFloor(floor: RootObjectVo<any>, namespace: string): boolean {
  return (floor.type && floor.type.namespace && floor.type.namespace === namespace) as boolean;
}

/**
 * 将返回楼层转化为可配置楼层
 * @param floorObject 楼层结构
 * @param structure 维护楼层结构表
 */
function unfoldRootObject(floorObject: RootObjectVo<any>, structure: any) {
  const obj: LoopObjectVo = {};
  Object.keys(floorObject.info || {}).forEach((key: string) => {
    Object.keys(structure[key] || {}).forEach((useKsy: string) => {
      obj[structure[key][useKsy]] = floorObject.info[key][useKsy] ?? "";
    });
  });
  return obj;
}

/**
 * 展开楼层列表
 * @param floors 楼层列表
 */
function floors2Fragment(floors: RootObjectVo<any>[]) {
  const obj: any = {};
  floors.forEach((floor: RootObjectVo<any>) => {
    obj[floor.uuid] = floor;
  });
  return obj;
}

export { definedFloor, unfoldRootObject, floors2Fragment };
